import { useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { Save } from "lucide-react";

const empty = {
  ad_soyad: "", tc_kimlik: "", uyelik_tarihi: "",
  adres: "", tel1: "", tel2: "", gsm1: "", gsm2: "", email: "",
  misas_hisse: 0, misas_kayit_no: "", misas_sayfa_no: "",
  mis_holding_hisse: 0, mis_holding_kayit_no: "", mis_holding_sayfa_no: "",
  koop_hisse: 0, koop_kayit_no: "", koop_sayfa_no: "",
  notlar: "",
};

function Field({ label, testid, children }) {
  return (
    <label className="block">
      <span className="block text-[11px] font-bold uppercase tracking-[0.1em] text-slate-500 mb-1.5">{label}</span>
      {children}
    </label>
  );
}
const inputCls = "w-full px-3 py-2.5 rounded-md border border-slate-200 focus:outline-none focus:ring-2 focus:ring-slate-900 text-sm bg-white";

export default function AddMember() {
  const [f, setF] = useState(empty);
  const [saving, setSaving] = useState(false);
  const nav = useNavigate();
  const set = (k, v) => setF(s => ({ ...s, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!f.ad_soyad.trim()) { toast.error("Ad Soyad zorunlu"); return; }
    if (f.misas_hisse === 0 && f.mis_holding_hisse === 0 && f.koop_hisse === 0) {
      toast.error("En az bir şirkette hisse girmelisiniz (>0)"); return;
    }
    setSaving(true);
    try {
      const r = await axios.post(`${API}/members`, {
        ...f,
        misas_hisse: Number(f.misas_hisse) || 0,
        mis_holding_hisse: Number(f.mis_holding_hisse) || 0,
        koop_hisse: Number(f.koop_hisse) || 0,
      });
      toast.success("Üye eklendi");
      nav(`/ortak/${r.data.id}`);
    } catch (e) {
      toast.error("Kayıt başarısız");
    } finally { setSaving(false); }
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.14em] text-slate-500 mb-2">Kayıt</div>
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">Yeni Üye Ekle</h1>
      </div>
      <form onSubmit={submit} className="space-y-6">
        <div className="crisp-card p-6 space-y-5">
          <h3 className="text-sm font-bold text-slate-900">Kişisel Bilgiler</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <Field label="Ad Soyad *">
              <input data-testid="add-ad-soyad" required className={inputCls} value={f.ad_soyad} onChange={e=>set("ad_soyad",e.target.value)} />
            </Field>
            <Field label="T.C. Kimlik No">
              <input data-testid="add-tc" className={inputCls} value={f.tc_kimlik} onChange={e=>set("tc_kimlik",e.target.value)} />
            </Field>
            <Field label="Üyelik Tarihi">
              <input data-testid="add-uyelik" placeholder="YYYY veya YYYY-MM-DD" className={inputCls} value={f.uyelik_tarihi} onChange={e=>set("uyelik_tarihi",e.target.value)} />
            </Field>
            <Field label="Adres">
              <input data-testid="add-adres" className={inputCls} value={f.adres} onChange={e=>set("adres",e.target.value)} />
            </Field>
            <Field label="Tel 1"><input data-testid="add-tel1" className={inputCls} value={f.tel1} onChange={e=>set("tel1",e.target.value)} /></Field>
            <Field label="Tel 2"><input data-testid="add-tel2" className={inputCls} value={f.tel2} onChange={e=>set("tel2",e.target.value)} /></Field>
            <Field label="GSM 1"><input data-testid="add-gsm1" className={inputCls} value={f.gsm1} onChange={e=>set("gsm1",e.target.value)} /></Field>
            <Field label="GSM 2"><input data-testid="add-gsm2" className={inputCls} value={f.gsm2} onChange={e=>set("gsm2",e.target.value)} /></Field>
            <Field label="E-posta">
              <input data-testid="add-email" type="email" placeholder="ornek@eposta.com" className={inputCls} value={f.email} onChange={e=>set("email",e.target.value)} />
            </Field>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {[
            { key:"misas", label:"Misaş", cls:"company-misas" },
            { key:"mis_holding", label:"Mis Holding", cls:"company-mh" },
            { key:"koop", label:"Lok. Tük. Koop.", cls:"company-koop" },
          ].map(c => (
            <div key={c.key} className="crisp-card p-6 space-y-4">
              <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider ${c.cls}`}>{c.label}</span>
              <Field label="Hisse Adedi">
                <input data-testid={`add-${c.key}-hisse`} type="number" min="0" className={inputCls}
                  value={f[`${c.key}_hisse`]} onChange={e=>set(`${c.key}_hisse`, e.target.value)} />
              </Field>
              <Field label="Üye Kayıt No">
                <input data-testid={`add-${c.key}-kayit`} className={inputCls} value={f[`${c.key}_kayit_no`]} onChange={e=>set(`${c.key}_kayit_no`, e.target.value)} />
              </Field>
              <Field label="Sayfa No">
                <input data-testid={`add-${c.key}-sayfa`} className={inputCls} value={f[`${c.key}_sayfa_no`]} onChange={e=>set(`${c.key}_sayfa_no`, e.target.value)} />
              </Field>
            </div>
          ))}
        </div>

        <div className="crisp-card p-6">
          <Field label="Notlar / Açıklama">
            <textarea data-testid="add-notlar" rows={4} className={inputCls} value={f.notlar} onChange={e=>set("notlar", e.target.value)} />
          </Field>
        </div>

        <div className="flex justify-end">
          <button data-testid="add-submit" disabled={saving} type="submit"
            className="inline-flex items-center gap-2 rounded-md bg-slate-900 text-white font-semibold px-5 py-3 hover:bg-slate-800 disabled:opacity-60">
            <Save size={16} /> {saving ? "Kaydediliyor..." : "Kaydet"}
          </button>
        </div>
      </form>
    </div>
  );
}
